import { h, render, Component } from 'preact';

export class Wizard extends Component {

  // constructor(props) {
  //   super(props);

  //   this.state = {
  //     activationBarcodeURL: '',
  //     activationURL: '',
  //     status: 'waiting'
  //   }
    
  // }

  render(props, state) {
		return (
      <span>
			<div id={props.id} class={"wizard"+(props.isPanel?' panel':'')+(props.classList?' '+props.classList:'')}>
        {props.title && 
        <h2>{props.title}</h2>}
        {props.children}
        <div id="desktopWizardBtns" style={props.next?"text-align:right;":''}>
          {props.prev &&
          <div style={props.next?"float:left;":''} class="touchBtn" onClick={props.prev.callback}><i class="fa fa-arrow-left"></i>&nbsp;{props.prev.label?props.prev.label:'Back'}</div> }
          {props.next && 
          <div class={"touchBtn primary" + (props.next.disabled ? ' disabled':'')} onClick={props.next.callback}>{props.next.label?props.next.label:'Continue'}&nbsp;<i class="fa fa-arrow-right"></i></div> }
        </div>
      </div>
      <div id="mobileWizardBtns" class="touchOptions">
        {(props.prev && props.prev.callback) &&
        <div class="touchBtn" onClick={props.prev.callback}><i class="fa fa-arrow-left"></i>&nbsp;{props.prev.label?props.prev.label:'Back'}</div> }
        {props.next && 
        <div class={"touchBtn primary" + (props.next.disabled ? ' disabled':'')} onClick={props.next.callback}>{props.next.label?props.next.label:'Continue'}&nbsp;<i class="fa fa-arrow-right"></i></div> }
      </div>
      </span>
		)
  }
}
